var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeeth23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 74,
    viewBox: "0 0 47 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2777_3297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6879 65.5203C12.3563 66.2978 32.3775 60.0783 36.5486 55.4138C40.7197 50.7492 44.0566 25.8715 41.5539 17.3198C39.0513 8.76809 31.5433 -0.561038 21.5327 0.216389C11.5221 1.77124 4.8484 20.4295 4.8484 39.0878C4.01419 57.746 7.35104 63.188 10.6879 65.5203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9483 39.0922L4.9484 39.0922V39.0878C4.9484 29.7692 6.61516 20.4532 9.52924 13.2759C10.9863 9.68728 12.7536 6.63727 14.7769 4.38907C16.7991 2.14212 19.0725 0.700817 21.5443 0.315793C26.5124 -0.0687732 30.864 2.05275 34.2895 5.3418C37.7167 8.63243 40.2109 13.0868 41.4579 17.3479C42.0794 19.4714 42.3402 22.6179 42.3142 26.2231C42.2882 29.826 41.9757 33.879 41.4548 37.8113C40.9338 41.7438 40.2047 45.5534 39.3459 48.6697C38.9165 50.2279 38.4551 51.6113 37.9718 52.7493C37.4879 53.8889 36.9847 54.7761 36.4741 55.3471C35.4453 56.4976 33.4276 57.7538 30.9386 58.9804C28.4535 60.2051 25.5115 61.394 22.6462 62.4136C19.781 63.4331 16.9947 64.2824 14.8216 64.8281C13.7348 65.101 12.8032 65.2976 12.0926 65.4016C11.7371 65.4537 11.4391 65.4823 11.2058 65.4862C10.9748 65.4901 10.8213 65.4692 10.7375 65.433C7.44967 63.1302 4.11487 57.733 4.9483 39.0922Z",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2777_3297",
    x: 0.71875,
    y: 0.170898,
    width: 45.6953,
    height: 73.416,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2777_3297"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2777_3297",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeeth23);
export default __webpack_public_path__ + "static/media/teeth23.ec7a90fcccf75c3b9555ce9c825255b4.svg";
export { ForwardRef as ReactComponent };